(function (angular) {
    'use strict';

    angular.module('dashboard')

        .component('blog', {
            bindings: {
                data: "="
            },
            controller: [function () {
                var ctrl = this;

                ctrl.date = function () {
                    return new Date(ctrl.data.isoDate);
                }

            }],
            templateUrl: "components/dashboard/templates/blogComponent.html"
        })

})(window.angular);